import { CORE_PERMISSIONS } from "./corePermissionKeys.js";
export const permissionDependencies = {
    // Manager permission dependencies
    [CORE_PERMISSIONS.RESPONDENT_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_READ,
        CORE_PERMISSIONS.RESPONDENT_LIST,
    ],
    [CORE_PERMISSIONS.RESPONDENT_READ]: [CORE_PERMISSIONS.RESPONDENT_LIST],
    [CORE_PERMISSIONS.RESPONDENT_DOCUMENT_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_DOCUMENT_READ,
    ],
    [CORE_PERMISSIONS.RESPONDENT_NOTE_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_NOTE_READ,
    ],
    [CORE_PERMISSIONS.RESPONDENT_CONTACT_WRITE]: [
        CORE_PERMISSIONS.RESPONDENT_CONTACT_READ,
    ],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS]: [
        CORE_PERMISSIONS.BOOKING_READ,
    ],
    [CORE_PERMISSIONS.BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS]: [
        CORE_PERMISSIONS.BOOKING_READ,
    ],
    [CORE_PERMISSIONS.BOOKING_WRITE]: [CORE_PERMISSIONS.BOOKING_READ],
    [CORE_PERMISSIONS.BOOKING_DOCUMENT_WRITE]: [
        CORE_PERMISSIONS.BOOKING_DOCUMENT_READ,
    ],
    [CORE_PERMISSIONS.SURVEY_WRITE]: [CORE_PERMISSIONS.SURVEY_READ],
    // External User permission dependencies
    [CORE_PERMISSIONS.SURVEY_COMPLETED_SEND]: [CORE_PERMISSIONS.SURVEY_READ],
    // Admin permission dependencies
    [CORE_PERMISSIONS.MANAGE_BOOKING_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_BOOKINGS,
    ],
    [CORE_PERMISSIONS.MANAGE_RESPONDENT_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_RESPONDENTS,
    ],
    [CORE_PERMISSIONS.MANAGE_RESPONDENT_CONTACTS]: [
        CORE_PERMISSIONS.MANAGE_RESPONDENTS,
    ],
    [CORE_PERMISSIONS.MANAGE_BOOKING_PAGE_COMPANIES]: [
        CORE_PERMISSIONS.MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES,
    ],
    // Sales and Invoicing dependencies admin
    [CORE_PERMISSIONS.CONFIGURE_INVOICING_AND_PAYMENTS]: [
        CORE_PERMISSIONS.MANAGE_INVOICING_AND_PAYMENTS_SYSTEM_CONFIG,
        CORE_PERMISSIONS.MANAGE_TAX_RATES,
        CORE_PERMISSIONS.MANAGE_ITEMS,
        CORE_PERMISSIONS.MANAGE_ACTIVITY_ITEMS,
    ],
    // Once Manage Invoices is granted, all sub-permissions are granted
    [CORE_PERMISSIONS.MANAGE_INVOICES]: [
        CORE_PERMISSIONS.VIEW_INVOICES,
        CORE_PERMISSIONS.CREATE_INVOICE,
        CORE_PERMISSIONS.EDIT_INVOICE,
        CORE_PERMISSIONS.CHANGE_INVOICE_STATUS,
        CORE_PERMISSIONS.EXPORT_AND_SEND_INVOICE,
    ],
    // if you create, view is required
    [CORE_PERMISSIONS.CREATE_INVOICE]: [
        CORE_PERMISSIONS.VIEW_INVOICES,
        CORE_PERMISSIONS.EDIT_INVOICE,
    ],
    // if you edit, view is required
    [CORE_PERMISSIONS.EDIT_INVOICE]: [CORE_PERMISSIONS.VIEW_INVOICES],
    // if you change status, view is required
    [CORE_PERMISSIONS.CHANGE_INVOICE_STATUS]: [CORE_PERMISSIONS.VIEW_INVOICES],
    // if you export and send, view is required
    [CORE_PERMISSIONS.EXPORT_AND_SEND_INVOICE]: [CORE_PERMISSIONS.VIEW_INVOICES],
    // Charges and Payments dependencies
    [CORE_PERMISSIONS.MANAGE_CHARGES_AND_PAYMENTS]: [
        CORE_PERMISSIONS.PERFORM_CHARGE,
        CORE_PERMISSIONS.REFUND_PAYMENT,
        CORE_PERMISSIONS.VIEW_PAYMENT_HISTORY,
    ],
    // individual dependencies
    [CORE_PERMISSIONS.VIEW_PAYMENT_HISTORY]: [CORE_PERMISSIONS.VIEW_INVOICES],
    [CORE_PERMISSIONS.REFUND_PAYMENT]: [
        CORE_PERMISSIONS.VIEW_INVOICES,
        CORE_PERMISSIONS.VIEW_PAYMENT_HISTORY,
    ],
    [CORE_PERMISSIONS.PERFORM_CHARGE]: [
        CORE_PERMISSIONS.VIEW_INVOICES,
        CORE_PERMISSIONS.VIEW_PAYMENT_HISTORY,
    ],
    // Workflows and Automations
    [CORE_PERMISSIONS.MANAGE_WORKFLOWS]: [
        CORE_PERMISSIONS.READ_WORKFLOWS,
        CORE_PERMISSIONS.WRITE_WORKFLOWS,
        CORE_PERMISSIONS.DELETE_WORKFLOWS,
    ],
    [CORE_PERMISSIONS.WRITE_WORKFLOWS]: [CORE_PERMISSIONS.READ_WORKFLOWS],
    [CORE_PERMISSIONS.DELETE_WORKFLOWS]: [CORE_PERMISSIONS.READ_WORKFLOWS],
};
//# sourceMappingURL=permissionDependencies.js.map